import React, { Component } from 'react';
import './portfolio.css';

export default class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFilter: 'All',
      isMobile: window.matchMedia("(max-width: 768px)").matches,
      openPanel: null, // Track which panel is open
      slideIndexes: {}, // Track current slide per item
    };
    this.sliderRefs = {};
  }

  setFilter = (category) => {
    this.setState({ currentFilter: category });
  }

  clearFilter = () => {
    this.setState({ currentFilter: 'All' });
  }

  handleResize = () => {
    this.setState({ isMobile: window.matchMedia("(max-width: 768px)").matches });
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  openPanel = (itemName) => {
    this.setState({ openPanel: itemName });
  }

  closePanel = () => {
    this.setState({ openPanel: null });
  }

  nextSlide = (itemName, slidesLength) => {
    this.setState((prevState) => {
      const current = prevState.slideIndexes[itemName] || 0;
      return {
        slideIndexes: {
          ...prevState.slideIndexes,
          [itemName]: (current + 1) % slidesLength,
        }
      };
    });
  }

  prevSlide = (itemName, slidesLength) => {
    this.setState((prevState) => {
      const current = prevState.slideIndexes[itemName] || 0;
      return {
        slideIndexes: {
          ...prevState.slideIndexes,
          [itemName]: (current - 1 + slidesLength) % slidesLength,
        }
      };
    });
  }

  render() {
    let resumeData = this.props.resumeData;
    let { currentFilter, isMobile, openPanel, slideIndexes } = this.state;

    return (
      <section id="portfolio">
        <div className="row">
          <h1>Check out some of my projects!</h1>
          <div className="filter-buttons">
            {
              resumeData.portfolio && resumeData.categories.map((item) => (
                <button
                  className="btn-dark text-white p-1 px-2 mx-5 btn fw-bold"
                  onClick={() => this.setFilter(item.category)}
                  key={item.category}
                >
                  {item.category}
                </button>
              ))
            }
            <button
              className="btn-dark text-white p-1 px-3 mx-5 fw-bold btn"
              onClick={this.clearFilter}
              style={{ backgroundColor: 'rgba(250, 182, 35, 0.8)' }}
            >
              Clear Filters
            </button>
          </div>
          <div className="twelve columns collapsed">
            <div id={`portfolio-wrapper${isMobile ? 'mobile-layout' : ''}`} className="one-col-tab">
              {
                resumeData.portfolio && resumeData.portfolio.map((item) => {
                  const isHidden = !item.categories.map((categories) => categories.category).includes(currentFilter) && currentFilter !== 'All';
                  const sliderId = `portfolio-item-${item.name}`;
                  return (
                      <div
                        className={`columns portfolio-item ${isHidden ? 'hidden' : ''}`}
                        key={item.name}
                        style={{
                        display: isHidden ? 'none' : 'block',
                        background: item.BackgroundColor,
                        borderColor: item.Color,
                        breakInside: 'avoid', // Prevent breaking inside columns
                        WebkitColumnBreakInside: 'avoid', // For Safari
                        pageBreakInside: 'avoid', // For print
                      }} >
                        
                    <div className="item-header" style={{ breakInside: 'avoid', WebkitColumnBreakInside: 'avoid', pageBreakInside: 'avoid' }}>
                      <h5 style={{color: item.Color, textAlign: 'center', marginTop: 10 }}>{item.name}</h5>
                      <h3 style={{color: item.Color, textAlign: 'center', marginTop: -20, marginBottom: -3, fontSize: 15 }}>{item.role}</h3>
                      <div className="item-wrap" style={{ cursor: 'pointer' }} onClick={() => this.openPanel(item.name)}>
                        <img src={item.CoverImage} />
                      </div>
                    </div>

                      {/* Modal Panel */}
                      {openPanel === item.name && (
                        <div className="portfolio-modal-overlay">
                          <div className="portfolio-modal-panel" style={{background: item.BackgroundColor, borderColor: item.Color}}>
                            <button className="portfolio-modal-close" onClick={this.closePanel}>X</button>
                            <div className="portfolio-item-meta">
                              <h2 style={{color: item.Color, fontWeight: 'bold', fontSize: 30}}>{item.name}</h2>
                              <p>{item.Studio && <b>Studio:</b>} {item.Studio} {item.Studio && <br />}
                              {item.description} <br /> <br />

                              <b>{item.engine}</b> {item.engine && <br />}
                              {item.teamSize && <b>Team Size:</b>} {item.teamSize} {item.teamSize && <br />}
                              {item.Timeframe && <b>Timeframe:</b>} {item.Timeframe} {item.Timeframe && <br />}
                              {item.role && <b>Role:</b>} {item.role} </p>{item.role && <br />}

                              <p>{item.responsibilities1 && <b>Achievements:</b>}</p>
                              <ul>
                                {item.responsibilities1 && <li>{item.responsibilities1}</li>}
                                {item.responsibilities2 && <li>{item.responsibilities2}</li>}
                                {item.responsibilities3 && <li>{item.responsibilities3}</li>}
                                {item.responsibilities4 && <li>{item.responsibilities4}</li>}
                                {item.responsibilities5 && <li>{item.responsibilities5}</li>}
                                {item.responsibilities6 && <li>{item.responsibilities6}</li>}
                              </ul>
                              <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <div className="overlayicon">
                                  <img src={item.iconImg} alt="icon" />
                                </div>
                              </a>
                            </div>
                            {/* Slideshow */}
                            <div className={`portfolio-item-images ${isMobile ? 'mobile-layout' : ''}`}>
                              {item.slides && item.slides.length > 0 && (
                                <>
                                  <img
                                    src={item.slides[slideIndexes[item.name] || 0].imgurl}
                                    className="item-img active"
                                    alt={`Slide ${(slideIndexes[item.name] || 0) + 1}`}
                                  />
                                  <button className="prev" style={{backgroundColor: item.Color}} onClick={() => this.prevSlide(item.name, item.slides.length)}>&#10094;</button>
                                  <button className="next" style={{backgroundColor: item.Color}} onClick={() => this.nextSlide(item.name, item.slides.length)}>&#10095;</button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}